import React from 'react';

import { Status } from 'app/zap-templates/types';
import { useQueryZapTemplates } from 'app/zap-templates/hooks';
import { useRouter } from 'app/developer-v3/hooks';

import ZapTemplates from './ZapTemplates';

function Container() {
  const { params } = useRouter();

  const [status, setStatus] = React.useState(params.status as Status);

  const { data, isLoading } = useQueryZapTemplates({
    keepPreviousData: true,
    staleTime: 60000,
  });

  const zapTemplates = (data?.pages ?? []).flatMap(pageOne => pageOne.data);

  return (
    <ZapTemplates
      isLoading={isLoading}
      onChangeStatus={setStatus}
      status={status}
      zapTemplates={zapTemplates}
    />
  );
}

export default Container;
